import { ColumnDef } from "@tanstack/react-table";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const ReferralCodeCol = (): ColumnDef<AccountTableUser> => ({
  header: "Referral code",
  accessorKey: "referral_code",
  cell: ({ getValue }) => {
    const referralCode = getValue() as number;
    return <>Referral{referralCode}</>;
  },
  size: 150,
  minSize: 150,
});
